import { Card, CardContent, CardHeader, CardTitle } from "../../../../../components/ui/card";
import { Separator } from "../../../../../components/ui/separator";
import { Skeleton } from "../../../../../components/ui/skeleton";
import { EntregoBaixaItem, EntregoOpsItem } from "../types";
import { EntregoBaixaItemCard } from "./entrego-baixa-item-card";
import { EntregoOpsTable } from "./entrego-ops-table";

interface EntregoBaixaSectionProps {
  opsList: EntregoOpsItem[];
  baixaList: EntregoBaixaItem[];
  selectedOps: string[];
  onSelectionChange: (selectedOps: string[]) => void;
  isLoadingOps: boolean;
  isLoadingBaixas: boolean;
  onStartDoc: (filterDate: string, listOps: string[]) => void;
  onSubmitDb: (filterDate: string, listOps: string[]) => void;
  isStartingDoc: boolean;
  isSubmittingDb: boolean;
}

export function EntregoBaixaSection({
  opsList,
  baixaList,
  selectedOps,
  onSelectionChange,
  isLoadingOps,
  isLoadingBaixas,
  onStartDoc,
  onSubmitDb,
  isStartingDoc,
  isSubmittingDb,
}: EntregoBaixaSectionProps) {
  if (isLoadingOps) {
    return (
      <Card>
        <CardContent className="py-12">
          <div className="text-center space-y-4">
            <div className="flex justify-center">
              <Skeleton className="h-12 w-12 rounded-full" />
            </div>
            <Skeleton className="h-4 w-48 mx-auto" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <CardHeader className="px-0 pt-0">
        <CardTitle className="text-2xl">ENTREGO</CardTitle>
      </CardHeader>

      <EntregoOpsTable
        opsList={opsList}
        selectedOps={selectedOps}
        onSelectionChange={onSelectionChange}
      />

      {selectedOps.length > 0 && (
        <>
          <Separator className="my-6" />

          {isLoadingBaixas ? (
            <Card>
              <CardContent className="py-12">
                <div className="text-center space-y-4">
                  <div className="flex justify-center">
                    <Skeleton className="h-12 w-12 rounded-full" />
                  </div>
                  <Skeleton className="h-4 w-56 mx-auto" />
                </div>
              </CardContent>
            </Card>
          ) : !Array.isArray(baixaList) || baixaList.length === 0 ? (
            <Card>
              <CardContent className="py-12">
                <div className="text-center">
                  <CardTitle className="text-xl">
                    Não há baixas de ENTREGO para serem finalizadas dos últimos
                    20 dias
                  </CardTitle>
                </div>
              </CardContent>
            </Card>
          ) : (
            <div className="space-y-4">
              {baixaList.map((baixa, index) => (
                <div key={`${baixa.data_romaneio}-${index}`}>
                  <EntregoBaixaItemCard
                    baixaItem={baixa}
                    selectedOps={selectedOps}
                    onStartDoc={onStartDoc}
                    onSubmitDb={onSubmitDb}
                    isStartingDoc={isStartingDoc}
                    isSubmittingDb={isSubmittingDb}
                  />
                  {index < baixaList.length - 1 && (
                    <Separator className="my-4" />
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
